// extracted by mini-css-extract-plugin
export default {"status":"Status_status__XDVDp","active":"Status_active__8yANl","inactive":"Status_inactive__NTiYD"};